exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.superScroll {\r\n    position: fixed;\r\n    width: 247.5px;\r\n    top:125px !important;\r\n    -webkit-transition: margin-top .25s ease-in-out;\r\n    transition: margin-top .25s ease-in-out;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    .hashtag {\r\n        font-size: 1.2rem;\r\n    }\r\n    .trendBrand{\r\n        font-size: 1.1rem;\r\n    }\r\n    .trend-topic-title{\r\n        font-size: 1.3rem;\r\n    }\r\n    .mobile-trending{\r\n        margin-bottom: 85px;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.mobile-card{\r\n    background-color: #fff;\r\n    padding: 15px;\r\n    border: 1px solid #e0e2e4;\r\n    border-radius: 5px;\r\n    height: 1000px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/trend-topics/trend-topics.component.css
// module id = ../../../../../src/app/trend-topics/trend-topics.component.css
// module chunks = main